import React from 'react';
import './HomeChargers.scss';
import { FormattedMessage } from 'react-intl';
import circuitSharingQplPdf from '../../client_customizations/assets/pdf/circuit-sharing-energy-management-device-qpl-updated-may-6-2026.pdf';

const HomeChargers = (props) => {
  return (
    <div className="page-home-chargers">
      <h1 className="title-home-chargers">
        <FormattedMessage
          id="homeChargers.title"
          defaultMessage="Select a charger that meets your needs"
          description="Select a charger that meets your needs"
        />
      </h1>
      <h2 className="subtitle-home-chargers">
        <FormattedMessage
          id="homeChargers.subtitle"
          defaultMessage="Browse home chargers to find the perfect fit for your EV and charging needs."
          description="Browse home chargers to find the perfect fit for your EV and charging needs."
        />
      </h2>
      <zr-chargers-catalog-widget
        lang={props.language.toLowerCase() ?? 'en'}
      ></zr-chargers-catalog-widget>
      <div className="home-chargers-button">
        <a href={circuitSharingQplPdf}>
          <button className="btn btn-smud-secondary">
            <FormattedMessage
              id="homeChargers.button"
              defaultMessage="Find other devices eligible for SMUD's Charge@Home program"
              description="Find other devices eligible for SMUD's Charge@Home program"
            />
          </button>
        </a>
      </div>
    </div>
  );
};

export default HomeChargers;
